import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
	contentContainer: {
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(2)
	},
	buttonWrapper: {
		position: 'relative'
	},
	buttonProgress: {
		color: theme.palette.primary.main,
		position: 'absolute',
		top: '50%',
		left: '50%',
		marginTop: -12,
		marginLeft: -12
	}
}));
